import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';
import { Dialog, DialogContent } from './ui/dialog';

const CulturalHighlight = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const c = t.cultural;
  const [video, setVideo] = useState(null);

  return (
    <section className="section-pad bg-[#14120d]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} />
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 mt-14">
          {c.shows.map((show, i) => (
            <Reveal key={show.id} delay={i * 100}>
              <div className="card-lux overflow-hidden h-full flex flex-col">
                <button
                  onClick={() => setVideo(show.id)}
                  className="group relative w-full aspect-video overflow-hidden"
                >
                  <img src={`https://i.ytimg.com/vi/${show.id}/sddefault.jpg`} alt={show.title} loading="lazy"
                    onError={(e) => { e.currentTarget.src = `https://i.ytimg.com/vi/${show.id}/hqdefault.jpg`; }}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute inset-0 bg-black/30 group-hover:bg-black/15 transition-colors" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-16 h-16 rounded-full bg-[#e6b83f]/90 flex items-center justify-center text-[#14120d] group-hover:scale-110 transition-transform">
                      <Play size={26} fill="currentColor" />
                    </span>
                  </span>
                </button>
                <div className="p-7">
                  <h3 className="font-deco text-2xl text-[#f7f1e3]">{show.title}</h3>
                  <div className="gold-line w-16 my-4" />
                  <p className="font-sans-el text-[16px] text-[#cbc4b3] font-light leading-relaxed">{show.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => navigate('/eventos-culturales')}
            className="btn-gold inline-flex items-center gap-2 px-8 py-4 rounded-sm text-[13px] tracking-[0.2em] uppercase font-medium"
          >
            {c.seeAll} <ArrowRight size={16} />
          </button>
        </div>
      </div>

      <Dialog open={!!video} onOpenChange={(o) => !o && setVideo(null)}>
        <DialogContent className="max-w-4xl bg-transparent border-0 p-0 shadow-none">
          {video && (
            <div className="aspect-video w-full">
              <iframe
                className="w-full h-full rounded-sm"
                src={`https://www.youtube.com/embed/${video}?autoplay=1`}
                title="LAJO"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default CulturalHighlight;
